export default "/assets/images/mila-room-showcase-02.06f8f844f3865268.webp";